export enum RequestStatus {
  PENDING = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface RequestStatusByName {
  [key: string]: RequestStatus;
}
